<template>
  <card-container :document="document" :target="target" :highlighted="highlighted">
    <card-title>
      <span class="is-ellipsed-tablet">
        <icon-waypoint-type :waypoint-type="document.waypoint_type" />
        <document-title :document="document" />
      </span>
    </card-title>

    <card-row>
      <card-region-item :document="document" />
    </card-row>

    <card-row>
      <card-elevation-item :elevation="document.elevation ?? undefined" />

      <textual-array :array="document.slackline_types" i18n i18n-context="slackline_types" />

      <marker-quality :quality="document.quality" />
    </card-row>
  </card-container>
</template>

<script setup lang="ts">
import CardContainer from './utils/CardContainer.vue';
import CardElevationItem from './utils/CardElevationItem.vue';
import CardRegionItem from './utils/CardRegionItem.vue';
import CardRow from './utils/CardRow.vue';
import CardTitle from './utils/CardTitle.vue';
import { cardProps } from './utils/card';

import { documentProperty } from '@/js/properties';

defineProps({ ...cardProps, ...documentProperty });
</script>
